import { isEmpty } from "lodash"
import PropTypes from "prop-types"
import React, { Component } from "react"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import { t } from "../../i18next"
import { PageNotFound } from "../common"
import { CodeTable, getCodeTableAttribute, getCodeTableEntries } from "../common/codeTableAccess"
import * as actions from "./redux/actions"
import { CodeTableEntryShape, DamageCaseIdShape, FeatureStateShape } from "./redux/shapes"
import { DamageCaseNavigation, DamageCasePage, DamageCasePageHeader } from "."

export class TradesPage extends Component {
  static propTypes = {
    damageCase: FeatureStateShape.isRequired,
    actions: PropTypes.object.isRequired,
    caseId: DamageCaseIdShape.isRequired,
    trades: PropTypes.arrayOf(CodeTableEntryShape),
    wrapperTexts: PropTypes.arrayOf(CodeTableEntryShape),
  }

  componentDidMount() {
    const { caseId, wrapperTexts } = this.props
    const { unsentCases } = this.props.damageCase
    const currentCase = unsentCases[caseId]

    if (!currentCase.wrapperTextCode && !isEmpty(wrapperTexts)) {
      this.selectWrapperText(caseId, wrapperTexts[0].code)()
    }
  }

  render() {
    const { caseId } = this.props
    const { unsentCases } = this.props.damageCase
    const currentCase = unsentCases[caseId]

    if (currentCase) {
      return this.renderCase(currentCase)
    } else {
      return <PageNotFound />
    }
  }

  toggleTrade = (caseId, code) => () => this.props.actions.toggleTrade(caseId, code)

  selectWrapperText = (caseId, code) => () => this.props.actions.rememberAttribute(caseId, "wrapperTextCode", code)

  renderCase(currentCase) {
    const { caseId, trades, wrapperTexts } = this.props
    const { tradeCodes, wrapperTextCode } = currentCase

    const submitCasePending = Boolean(this.props.damageCase.submitCasePending.find(id => id === caseId))
    const submitCaseError = this.props.damageCase.submitCaseError[caseId]
    const dismissSubmitCaseError = () => this.props.actions.dismissSubmitCaseError(caseId)

    return (
      <DamageCasePage
        className="damage-case-trades-page"
        submitPending={submitCasePending}
        submitError={submitCaseError}
        dismissSubmitCaseError={dismissSubmitCaseError}
      >
        <DamageCasePageHeader caseId={caseId} />
        <div className="app-content">
          <DamageCaseNavigation className="app-content_left" caseId={caseId} currentPage="trades" />
          <div className="app-content_middle">
            <h2>{t("damageCase.tradesWithCount", { count: tradeCodes.length })}</h2>
            <div className="trades chewbacca">
              {trades.map(entry => (
                <button
                  key={entry.code}
                  className={`item ${tradeCodes.includes(entry.code) ? "selected" : ""}`}
                  onClick={this.toggleTrade(caseId, entry.code)}
                >
                  {getCodeTableAttribute(trades, entry.code, "title")}
                </button>
              ))}
            </div>
          </div>
          <div className="app-content_middle wrapperText">
            <h2>{t("damageCase.defaultText")}</h2>
            <div className="wrapperText chewbacca">
              {wrapperTexts.map(entry => (
                <button
                  key={entry.code}
                  className={`item ${entry.code === wrapperTextCode ? "selected" : ""}`}
                  onClick={this.selectWrapperText(caseId, entry.code)}
                >
                  {getCodeTableAttribute(wrapperTexts, entry.code, "title")}
                  <div className="description">{getCodeTableAttribute(wrapperTexts, entry.code, "description")}</div>
                </button>
              ))}
            </div>
          </div>
        </div>
      </DamageCasePage>
    )
  }
}

/* istanbul ignore next */
function mapStateToProps(state, ownProps) {
  const { caseId } = ownProps.match.params

  const trades = getCodeTableEntries(state, CodeTable.trades).sort((a, b) =>
    a.titleDe.toLocaleLowerCase().localeCompare(b.titleDe.toLocaleLowerCase()),
  )

  const wrapperTexts = getCodeTableEntries(state, CodeTable.damageCaseDefaultTexts)

  return {
    damageCase: state.damageCase,
    caseId,
    trades,
    wrapperTexts,
  }
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TradesPage)



// WEBPACK FOOTER //
// ./src/features/damage-case/TradesPage.js